<!--
/**
* @name: ApplyDetail.vue
* @description: 销售申请详情页面
* @author: 杨波
* @create: 2020/08/11 09:40:37
* @update: 2020/08/11 09:40:37
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-form titleAlign="right" titleWidth="100px" contentWidth="400px">
      <y-form-item title="门店ID:">
        <span>{{ basicData.shopCode }}</span>
      </y-form-item>
      <y-form-item title="门店名称:">
        <span>{{ basicData.shopName }}</span>
      </y-form-item>
      <y-form-item title="推广公司:">
        <span>{{ basicData.companyName }}</span>
      </y-form-item>
      <y-form-item title="销售渠道:">
        <span>{{ basicData.channelName }}</span>
      </y-form-item>
      <y-form-item title="申请销售商品货号:">
        <span>{{ basicData.goodsNumber }}</span>
      </y-form-item>
      <y-form-item title="申请销售商品名称:">
        <span>{{ basicData.goodsNumberName }}</span>
      </y-form-item>
      <y-form-item title="审核状态:">
        <span>{{ basicData.verifyStatus }}</span>
      </y-form-item>
      <y-form-item title="申请时间:">
        <span>{{ basicData.createTime }}</span>
      </y-form-item>
      <y-form-item title="申请原因:">
        <span>{{ basicData.applyReason }}</span>
      </y-form-item>
      <y-form-item title="拒绝原因:">
        <span>{{ basicData.rejectReason }}</span>
      </y-form-item>
      <y-form-item title="关联控货信息:">
        <k-button type="primary" size="mini" style="width: 40px;" @click="preview">查看</k-button>
      </y-form-item>
    </y-form>
    <!-- 查看控货基本信息弹窗区域 -->
    <k-popup bind="v-if" layout="header,body,close,mask" title="控货基本信息" :show.sync="popupShow">
      <div style="width: 1000px;">
        <y-form titleAlign="right" titleWidth="150px" contentWidth="1000px">
          <y-form-item title="控货编码:">
            <span>{{ controlDetail.code }}</span>
          </y-form-item>
          <y-form-item title="控货名称:">
            <span>{{ controlDetail.name }}</span>
          </y-form-item>
          <y-form-item title="控货渠道:">
            <span>{{ controlDetail.channelName }}</span>
          </y-form-item>
          <y-form-item title="控货时间范围:">
            <span>{{ controlDetail.controlStartTime }} ~ {{ controlDetail.controlEndTime }}</span>
          </y-form-item>
          <y-form-item title="控货原因:">
            <span>{{ controlDetail.controlReason | filter(this.controlReasonlList) }}</span>
          </y-form-item>
          <y-form-item title="备注:">
            <span>{{ controlDetail.remark }}</span>
          </y-form-item>
          <y-form-item title="已选商品:">
            <k-table :data="selectedGoodsList" height="350px" :rightFixedNumber="1" :columns="initColumns()"></k-table>
          </y-form-item>
          <y-form-item title="控货类型:">
            <span>{{ controlDetail.controlType == "1" ? "按门店控货" : "按区域控货" }}</span>
          </y-form-item>
          <y-form-item title="已选门店:" v-if="controlDetail.controlType == '1'">
            <span>{{ selectDealersList }}</span>
          </y-form-item>
          <y-form-item title="已选区域:" v-if="controlDetail.controlType == '2'">
            <span>{{ selectedAreaList }}</span>
          </y-form-item>
          <y-form-item title="非被控门店/区域是否正常销售:">
            <span>{{ controlDetail.otherCanSell == "1" ? "是" : "否" }}</span>
          </y-form-item>
          <y-form-item title="被控门店/区域是否可申请销售:">
            <span>{{ controlDetail.otherCallApply == "1" ? "是" : "否" }}</span>
          </y-form-item>
          <y-form-item title="状态:">
            <span>{{ controlDetail.status == "1" ? "是" : "否" }}</span>
          </y-form-item>
        </y-form>
      </div>
    </k-popup>
    <!-- 查看控货基本信息弹窗区域 end-->
  </y-view>
</template>

<script>
import {
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GOODS_APPLY_INFO,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CONTROL_INFO,
  NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST,
  NESTLE_TRADE_BACK_SERVER_BASE_DATA_AREA_PROVIDER,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_LIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
} from "@/assets/modules/apiList";

export default {
  data() {
    return {
      popupShow: false,
      goodsList: [],
      isLoading: false,
      controlDetail: {},
      selectedGoodsList: [],
      controlReasonlList: [],
      selectedAreaList: "",
      selectDealersList: "",
      provinceList: [],
      dealersList: [],
      basicData: {},
      channelList: [],
      //  1 待子公司审核审核 5待总部审核 10审核通过 20拒绝
      statusList: [
        { code: "1", name: "待子公司审核审核" },
        { code: "5", name: "待总部审核" },
        { code: "10", name: "审核通过" },
        { code: "20", name: "审核拒绝" },
      ],
    };
  },
  filters: {
    filter(code, arr) {
      let tmp = [];
      arr.forEach((a) => {
        if (code == a.value) {
          tmp.push(a.name);
        }
      });
      return tmp.join(",");
    },
  },
  methods: {
    initColumns() {
      return [
        {
          name: "商品系列名称",
          style: {
            width: 80,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
          customRender: (row) => {
            const goodsSeriesNameStr = <span>{row.goodsMaterialExtendVO.goodsSeriesName}</span>;
            return <div>{goodsSeriesNameStr}</div>;
          },
        },
        {
          name: "商品名称",
          field: "goodsNameSale",
          style: {
            width: 150,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "商品货号",
          field: "goodsCodeSale",
          style: {
            width: 80,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
      ];
    },
    preview() {
      this.getReasonList();
      this.getControlDetail();
      this.popupShow = true;
    },
    deleteRow() {},
    getDetails(id) {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GOODS_APPLY_INFO,
        para: { id },
      })
        .then((res) => {
          this.basicData = res;
          this.statusList.forEach((d) => {
            if (res.verifyStatus == d.code) {
              this.basicData.verifyStatus = d.name;
            }
          });
          this.channelList.forEach((v) => {
            if (res.channelCode == v.code) {
              this.basicData.channelName = v.name;
            }
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getReasonList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
        para: {
          parentCode: "controlReason",
        },
      }).then((res) => {
        this.controlReasonlList = res;
      });
    },
    getControlDetail() {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CONTROL_INFO,
        para: { controlCode: this.basicData.controlCode },
      })
        .then((res) => {
          this.controlDetail = res;
          let goodsNumberList = res.goodsNumberList;
          let selectedGoodsList = [];
          for (let i = 0; i < goodsNumberList.length; i++) {
            for (let j = 0; j < this.goodsList.length; j++) {
              if (goodsNumberList[i] == this.goodsList[j].goodsCodeSale) {
                selectedGoodsList.push(this.goodsList[j]);
              }
            }
          }
          this.selectedGoodsList = selectedGoodsList;
          if (res.controlType == "1") {
            let selectDealersList = [];
            let shopList = res.shopList;
            for (let i = 0; i < shopList.length; i++) {
              for (let j = 0; j < this.dealersList.length; j++) {
                if (shopList[i] == this.dealersList[j].shopCode) {
                  selectDealersList.push(this.dealersList[j].shopName);
                }
              }
            }
            this.selectDealersList = selectDealersList.join(",");
          } else {
            let selectedAreaList = [];
            let areaList = res.areaList;
            for (let i = 0; i < areaList.length; i++) {
              for (let j = 0; j < this.provinceList.length; j++) {
                if (areaList[i] == this.provinceList[j].areaCode) {
                  selectedAreaList.push(this.provinceList[j].areaName);
                }
              }
            }
            this.selectedAreaList = selectedAreaList.join(",");
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getGoodsList() {
      this.$fetch({
        api: NESTLE_GOODS_BACK_SERVER_GOODS_SALE_LIST,
        para: {},
      }).then((res) => {
        this.goodsList = res;
      });
    },
    getDealersList() {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_LIST,
        para: {},
      }).then((res) => {
        this.dealersList = res;
      });
    },
    getProvince() {
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_BASE_DATA_AREA_PROVIDER,
        para: {},
      }).then((res) => {
        this.provinceList = res;
      });
    },
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {},
      }).then((res) => {
        this.channelList = res || [];
      });
    },
  },
  created() {
    this.getGoodsList();
    this.getDealersList();
    this.getProvince();
    this.getChannelList();
    const { id, view } = this.$route.query;
    if (id) {
      this.isEdit = false;
      this.isView = true;
      setTimeout(this.getDetails(id), 100);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id, view } = to.query;
    if (id) {
      this.isEdit = false;
      this.isView = true;
      setTimeout(this.getDetails(id), 100);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
    next();
  },
};
</script>

<style lang="postcss" module="css"></style>
